import {noop} from '../utils/utils.js';
import config from '../utils/config.js';

const DEFAULT_BI_URL = 'https://frog.wix.com/';

const BI_ENDPOINT = '/bb?src=29';

const EVID_MAP = {
    client: 31,
    navigation: 35,
    wix: 32,
    scripts: 33,
    images: 34,
    fonts: 36,
    paint: 37,
    interactive: 38,
    'largest-contentful-paint': 39,
    'layout-shift': 40,
    hidden: 41,
    'first-input': 42
};

const PROP_MAP = {
    evid: 'evid',
    vsi: 'viewerSessionId',
    rid: 'requestId',
    sid: 'sessionId',
    vid: 'visitorId',
    msid: 'metaSiteId',
    pid: 'landingPageId'
};

export default function sendBI({navigator, bi = {}, wixBiSession = bi.wixBiSession, serviceTopology = {}, rendererModel = {}}, measurements) {
    const {forceBi, sampleRatio} = config;
    if (!wixBiSession || (wixBiSession.suppressbi && !forceBi)) {
        return;
    }

    const urlBase = serviceTopology.biServerUrl || DEFAULT_BI_URL;

    measurements.forEach(measurement => measurement.then(result => {
        const evid = EVID_MAP[result.entryType];
        if (!evid) {
            return;
        }

        if (sampleRatio) {
            const seed = wixBiSession.coin || parseInt(wixBiSession.viewerSessionId, 16);
            if (seed % sampleRatio) {
                return;
            }
        }

        const resultFields = Object.entries(result)
            .filter(([key, value]) => key !== 'detail' && typeof value !== 'object' && !Number.isNaN(value))
            .map(([key, value]) => {
                let fixedValue;
                switch (typeof value) {
                case 'string':
                    fixedValue = encodeURIComponent(value);
                    break;
                case 'boolean':
                    fixedValue = value ? 1 : 0;
                    break;
                default:
                    fixedValue = value;
                }
                return `${key.replace(/-/g, '_')}=${fixedValue}`;
            });
        if (!resultFields.length) {
            return;
        }

        const fixedFields = [
            BI_ENDPOINT,
            `evid=${evid}`
        ];
        addFields(fixedFields, wixBiSession);
        addFields(fixedFields, rendererModel);

        const urlParams = [...fixedFields, ...resultFields].join('&');
        const url = (new URL(urlParams, urlBase)).href;

        if (forceBi) {
            (new Image()).src = url;
        } else if (bi.sendBeacon) {
            bi.sendBeacon(url);
        } else if (wixBiSession.sendBeacon) {
            wixBiSession.sendBeacon(url);
        } else if (navigator.sendBeacon) {
            navigator.sendBeacon(url);
        }
    }, noop));
}

function addFields(fields, src) {
    return Object.entries(PROP_MAP)
        .filter(([, orig]) => src.hasOwnProperty(orig))
        .reduce((acc, [key, orig]) => {
            acc.push(`${key}=${src[orig]}`);
            return acc;
        }, fields);
}
